module.exports = __webpack_public_path__ + "static/media/Autometrics.0d426f86.pdf";